"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepperRange = exports.StepperMessage = exports.StepperLine = exports.StepperLabel = exports.StepperInput = exports.StepperButton = exports.Stepper = void 0;

var _stylitas = require("@creditas/stylitas");

var _stepper = require("./stepper.style");

const Stepper = _stylitas.styled.div`
  ${_stepper.stepper};
`;
exports.Stepper = Stepper;
const StepperButton = _stylitas.styled.button`
  ${_stepper.button};
`;
exports.StepperButton = StepperButton;
const StepperInput = _stylitas.styled.input`
  ${_stepper.input}
  ${_stepper.inputDisabled}
`;
exports.StepperInput = StepperInput;
const StepperLabel = _stylitas.styled.label`
  ${_stepper.label};
`;
exports.StepperLabel = StepperLabel;
const StepperLine = _stylitas.styled.span`
  ${_stepper.line};
`;
exports.StepperLine = StepperLine;
const StepperMessage = _stylitas.styled.p`
  ${_stepper.message};
`;
exports.StepperMessage = StepperMessage;
const StepperRange = _stylitas.styled.div`
  ${_stepper.range};
`;
exports.StepperRange = StepperRange;